/**
 * DevicesCtrl controller
 * Show all devices
 */

/**
 * DevicesCtrl controller
 *
 * @class DevicesCtrl
 * @memberof mwApp/devices
 * @see mwApp/devices
 *
 * @ngdoc controller
 * @name mwApp/devices.controller:DevicesCtrl
 */
/* @ngInject */
export default function DevicesCtrl ($scope, Device) {
  var vm = this
  vm.isFound = true

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Devices list
   *
   * @memberof mwApp/devices.controller:DevicesCtrl
   * @type {models.Device[]}
   */
  vm.devices = []

  /**
   * Get Devices from backend
   *
   * @memberof mwApp/devices.controller:DevicesCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getDevices = function (tableState) {
    // set default sort by id
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'id'
      tableState.sort.reverse = false
    }

    Device.loadSmart(tableState, {}, 'api/devices/')
      .then(
        data => {
          vm.devices = data.content
          vm.isFound = !!vm.devices.length
          $scope.loading = false
        }
      )
  }

  /**
   * Delete device
   *
   * @memberof mwApp/devices.controller:AddDeviceCtrl
   */
  vm.delete = function (device) {
    device._delete()
      .then(() => $scope.$broadcast('refreshTable'))
  }
}
